import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import ErrorBoundary from "./components/common/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <ErrorBoundary
    fallback={
      <div style={{ padding: "2rem", color: "#fff", textAlign: "center" }}>
        <h2>Упс! Что-то пошло не так 👾</h2>
        <button onClick={() => window.location.reload()}>Обновить страницу</button>
      </div>
    }
  >
    <App />
  </ErrorBoundary>
);
